
































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ReportRTRow } from '../table-data/ReportRtRow';
import { Classificator } from '../../../common/types/Classificator';
import { Transfert } from '../../../common/types/Transfert';
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"

@Component({})
export default class ReportRt extends Vue {
    
    @Prop({
        type: Array,
        required: true,
    })
    public tableData!: ReportRTRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]
    
    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propTransferts!: Transfert[]
     
    public classificators: string[] = this.expenses.filter(it => it.active).map(it => it.key)
    public transferts: string[] = this.propTransferts.filter(it => it.active).map(it => it.key)
    public isProjectStayRight = this.transferts[this.transferts.length - 1] === "project" || !this.transferts.includes("project")

    public total = this.tableData[0]
    public totalRows = this.tableData.length - 1
    public perPage = 200

    private created() {
        this.tableData = this.tableData.slice(1)
        this.handlePageChange(1)


        console.log(this.total)
        console.log(this.totalRows)
    }

    public handlePageChange(page: number) {
        const indexedPage = page - 1
        this.currentPage = page
        const startIndex = indexedPage * this.perPage
        const endIndex = startIndex + this.perPage
        this.currentItems = this.tableData.slice(startIndex, endIndex)
    }
    
    public currentPage = 1
    public currentItems: ReportRTRow[] = []

    public columnsNameMap: Record<string, string> = {

        'gr': 'ФГ',
        'pgr': 'ФПГ',
        'abp': 'АБП',
        'prg': 'БП',
        'ppr': 'БПП',
        'spf': 'СПФ',

        'name': 'Наименование',
        'total_amount': 'Итого по трансфертам',
        'month1': 'январь',
        'month2': 'февраль',
        'month3': 'март',
        'month4': 'апрель',
        'month5': 'май',
        'month6': 'июнь',
        'month7': 'июль',
        'month8': 'август',
        'month9': 'сентябрь',
        'month10': 'октябрь',
        'month11': 'ноябрь',
        'month12': 'декабрь',
        'year': 'год',
    }
    public transfertColorsMap: Record<string, string> = {
        'funding': '#FFE699',
        'gu': '#C6E0B4',
        'transfer_group': '#BDD7EE',
        'direction': '#C9C9C9',
    }

    public formatDigitsGrouping = formatDigitsGrouping

}
